
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { orgapi } from "../../ApiNames";

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data,
});
export const fetchdreportdatasuccess = (drepdata:any)=>({
    type : 'fetch_dreport_data_success',
    payload:drepdata,
});
export const fetchdata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid};
            const apiname = orgapi.orgdonreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchdgendata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid};
            const apiname = orgapi.orgfunreport;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdreportdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};

